module.exports = __webpack_public_path__ + "img/icon-wechat.68fe2e55.svg";